import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GivelifyLabel } from '@givelify/givelify-ui';
import { styled, List } from '@mui/material';

export const TitleIntro = styled('div')(({ theme }) => ({
    textAlign: 'center',
    alignSelf: 'start',
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
        textAlign: 'left',
        padding: theme.spacing(0, 4, 0, 0),
    },
}));

export const IntegrationTitle = styled(GivelifyLabel)({
    margin: '5px auto 0',
});

export const TitleContent = styled(GivelifyLabel)(({ theme }) => ({
    margin: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
        width: '70%',
    },
}));

export const Expect = styled(GivelifyLabel)(({ theme }) => ({
    color: theme.legacy.palette.text.primary,
}));

export const TitleCheckbox = styled(List)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    '& > li': {
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            paddingLeft: 0,
            justifyContent: 'flex-start',
        },
    },
}));

export const CheckIcon = styled(FontAwesomeIcon)({
    color: '#85919F',
});

export const DialogContent = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
        gridArea: '1 / 2 / 2 / 3',
        textAlign: 'left',
        marginTop: '40px',
    },
}));
